import { i18nClient } from '@sailor/i18n-mach-pro'
import resources from './locales/resources'

i18nClient.init({
  defaultNS: 'translation',
  fallbackLng: 'en',
  fallbackNS: 'translation',
  resources,
})

export default i18nClient
